import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

export default function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  width = 480,
}) {
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            key="modal-bg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15 }}
            className="fixed inset-0 bg-black/55 backdrop-blur-sm"
            style={{ zIndex: 90 }}
            onClick={onClose}
          />
          <motion.div
            key="modal-fg"
            initial={{ opacity: 0, y: 8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.98 }}
            transition={{ duration: 0.18, ease: "easeOut" }}
            className="fixed inset-0 sm:grid sm:place-items-center pointer-events-none"
            style={{ zIndex: 92 }}
          >
            <div
              className="pointer-events-auto bg-ide-panel border-ide-border shadow-soft overflow-hidden flex flex-col w-screen sm:h-auto sm:w-auto sm:rounded-xl sm:border"
              style={{
                ...(typeof width === "number" ? { maxWidth: width } : {}),
                // Mobile: full-height modal pinned to dvh so the iOS URL
                // bar doesn't push its bottom off-screen. `sm:h-auto`
                // overrides this on tablet+ via a Tailwind media query.
                height: "100dvh",
              }}
            >
              <div className="flex items-center px-4 py-2.5 border-b border-ide-border">
                <span className="text-sm font-medium text-ide-text">{title}</span>
                <button
                  className="ml-auto text-ide-mute hover:text-ide-text rounded p-1 hover:bg-ide-surface transition-colors min-h-[36px] min-w-[36px] flex items-center justify-center"
                  onClick={onClose}
                  aria-label="Close"
                >
                  <X className="h-4 w-4" />
                </button>
              </div>
              <div className="px-4 py-3 flex-1 overflow-auto">{children}</div>
              {footer && (
                <div className="flex items-center gap-2 justify-end px-4 py-2.5 border-t border-ide-border bg-ide-panel2">
                  {footer}
                </div>
              )}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
